<template>
  <div class="menu">

    <div :class="['menu-content-wrapper', {'free': specialMenu}]">

      <!-- Title -->
      <div class="menu-title">
        <div class="icon logga" v-touch:tap="goToFirst"></div>
      </div>

      <!-- Search field -->
      <!--<search-field-->
        <!--:useBtn="false"-->
        <!--:btnText="$lang.search"-->
        <!--:placeholderText="$lang.search_txt"-->
        <!--:emptyText="$lang.empty_search"-->
      <!--&gt;</search-field>-->

      <!-- Burger menu -->
      <div class="burger-wrapper">
        <div :class="['burger-menu', {'open': openMenu}]" v-touch:tap="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <!-- Menu items -->
      <transition name="slidemenu">
        <div v-if="openMenu" class="m-option-wrapper">
          <div class="option-holder">
            <div v-for="(box, i) in menuItems.items" :key="i"
              :class="[
                 'm-option',
                 {'selected': ($root.shared.currentPage === box.name)},
                 (box.class)
               ]"
              v-touch:tap="menuSelect(box.name)"
            >
              <h2 v-if="($lang[box.txt_over] !== undefined)">{{$lang[box.txt_over]}}</h2>
              <h2>{{ $lang[box.txt] }}</h2>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade-bg">
        <div v-if="openMenu" class="menu-bg"></div>
      </transition>

    </div>
  </div>
</template>

<script>
import Menu from '../../assets/data/menu.json'
// import Search from '../../components/search-bar/'

export default {
  name: 'top-menu',
  data () {
    return {
      menuItems: Menu,
      openMenu: false,
      searchValue: '',
      searchFocus: false,
      doneSections: [],
      specialMenu: false
    }
  },
  props: {
    isDesktop: {
      type: Boolean,
      required: false
    },
    selected: {

    }
  },
  mounted () {
    this.specialMenu = (this.$root.shared.currentPage === 'Oversight')
  },
  methods: {
    goToFirst () {
      let self = this
      return self.onGoToFirst()
    },
    onGoToFirst () {
      this.$router.push({name: 'Home'})
    },
    toggleMenu () {
      let self = this
      return self.onToggleMenu()
    },
    onToggleMenu () {
      this.openMenu = !this.openMenu
    },
    menuSelect (name) {
      let self = this
      return () => {
        self.onMenuSelect(name)
      }
    },
    onMenuSelect (name) {
      if (this.$root.shared.currentPage === name) {
        this.openMenu = false
      } else {
        this.$root.shared.currentPage = name
        this.$router.push({name: name})
      }
    },
    checkForFocus () {
      let self = this
      return self.onCheckForFocus()
    },
    onCheckForFocus () {
      this.searchFocus = true
    },
    removeInputFocus () {
      let self = this
      return self.onRemoveInputFocus()
    },
    onRemoveInputFocus () {
      this.searchFocus = false
    }
  },
  components: {
    // 'search-field': Search
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menu/index.vue